module.exports = __webpack_public_path__ + "static/media/advincula-product-img@2x.e4101249.png";